import { BLOOMREACH_PIXEL_ACCOUNT_ID, getDeploymentEnvironment } from '../../../../../config/config';

export const defaultBRData = {
    acct_id: BLOOMREACH_PIXEL_ACCOUNT_ID,
    // domain_key: process.env.GATSBY_BLOOMREACH_PIXEL_DOMAIN_KEY,

    debug: getDeploymentEnvironment() !== 'production',
    test_data: getDeploymentEnvironment() !== 'production',
};
